import NonMemberSignup from "../Pages/User/NonMemberSignup/NonMemberSignup";
import PrivateRoute from "../Components/Common/PrivateRoute/PrivateRoute";
import MobileHeader from "../Components/User/MobileHeader/MobileHeader";
import PublicRoute from "../Components/Common/PublicRoute/PublicRoute";
import CreateBooking from "../Pages/User/CreateBooking/CreateBooking";
import Dashboard from "../Pages/User/Dashboard/Dashboard";
import Sidebar from "../Components/User/Sidebar/Sidebar";
import Bookings from "../Pages/User/Bookings/Bookings";
import Header from "../Components/User/Header/Header";
import Upgrade from "../Pages/User/Upgrade/Upgrade";
import Profile from "../Pages/User/Profile/Profile";
import { Outlet, RouteObject } from "react-router";
import Signup from "../Pages/User/Signup/Signup";
import Login from "../Pages/User/Login/Login";
import styles from "./UserRoutes.module.scss";

const UserLayout = () => {
  return (
    <div className={styles.userLayoutContainer}>
      <div className={styles.userLayoutHeader}>
        <div className={styles.desktopHeader}>
          <Header />
        </div>
        <div className={styles.mobileHeader}>
          <MobileHeader />
        </div>
      </div>
      <div className={styles.userLayoutBody}>
        <div className={styles.sidebar}>
          <Sidebar />
        </div>
        <div className={styles.userLayoutContent}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const userRoutes: RouteObject[] = [
  {
    path: "/login",
    element: (
      <PublicRoute isAuthPage={true}>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/signup",
    element: (
      <PublicRoute isAuthPage={true}>
        <Signup />
      </PublicRoute>
    ),
  },

  {
    path: "/signup/nonmember",
    element: (
      <PublicRoute isAuthPage={true}>
        <NonMemberSignup />
      </PublicRoute>
    ),
  },

  {
    element: <UserLayout />,
    children: [
      {
        path: "/",
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/upgrade",
        element: (
          <PrivateRoute>
            <Upgrade />
          </PrivateRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
      },
      {
        path: "/bookings",
        element: (
          <PrivateRoute>
            <Bookings />
          </PrivateRoute>
        ),
      },
      {
        path: "/bookings/create",
        element: (
          <PrivateRoute>
            <CreateBooking />
          </PrivateRoute>
        ),
      },
    ],
  },
];

export default userRoutes;
